import React from "react";
import { Subscription } from "./Subscription";
import styles from "./Subscriptions.module.scss";
import { useSubscriptions } from "features/patientDashboard/hooks/useSubscriptions";
import { Card } from "components/Card";
import { Patient } from "types/patient";
import { Subscription as SubscriptionType } from "types/Subscription";

export const Subscriptions: React.FC<{
  patient: undefined | Partial<Patient>;
}> = ({ patient }) => {
  const patientId = patient.id;
  const { subscriptions } = useSubscriptions(patientId);

  if (subscriptions === undefined || subscriptions.length === 0) {
    return null;
  }
  const sortedSubscriptions = [...subscriptions].sort((a, b) => {
    const aTime = a.nextPurchaseDate ? new Date(a.nextPurchaseDate).getTime() : Number.POSITIVE_INFINITY;
    const bTime = b.nextPurchaseDate ? new Date(b.nextPurchaseDate).getTime() : Number.POSITIVE_INFINITY;
    return aTime - bTime;
  });

  const activeSubcription = [];
  const failedSubscription = [];
  const otherSubscription = [];

  for (const key in sortedSubscriptions) {
    const subs = sortedSubscriptions[key];
    if (
      subs.subscriptionStatus === "PAYMENT FAILED" ||
      subs.cycleStatus === "payment_error"
    ) {
      failedSubscription.push(subs);
    } else if (subs.subscriptionStatus === "ACTIVE") {
      activeSubcription.push(subs);
    } else {
      otherSubscription.push(subs);
    }
  }

  const newSortedSubscriptions = failedSubscription.concat(
    activeSubcription,
    otherSubscription
  );
  return <UnconnectedSubscriptions subscriptions={newSortedSubscriptions} />;
};

export const UnconnectedSubscriptions: React.FC<{
  subscriptions: SubscriptionType[];
}> = ({ subscriptions }) => (
  <>
    <Card className={styles.card}>
      <h4 className={styles.headline}>Subscriptions</h4>
      <ul className={styles.list}>
        {subscriptions.map((subscription, i) => (
          <li key={subscription.subscriptionId}>
            {i > 0 ? <hr className={styles.separator} /> : null}{" "}
            {/* Insert a separator between each element */}
            <Subscription subscription={subscription} />
          </li>
        ))}
      </ul>
    </Card>
  </>
);
